import {Injectable} from '@angular/core';
import {LocalStorageService} from './local-storage.service';
import {ConsolidatedProfile} from '../../shared/models/operation-mode.model';
import {AppConfig} from '../../shared/config/app-config';
import {ApiClientHelper} from '../helpers/api-client.helper';

@Injectable({
	providedIn: 'root'
})
export class OperationModeService {
	private consolidationExpiryDate: any;
	private hasClaimRequest: boolean;
	private hasDuplicatedProfile: boolean;
	private currentBusinessOwnerId: number;
	private userNavigation: string;

	constructor(
		private localStorage: LocalStorageService,
		public config: AppConfig,
		private apiClientHelper: ApiClientHelper,
	) {
		// const dupProfile = this.localStorage.get('hasDuplicatedProfile');
		// let hasDuplicatedProfile;
		// if (dupProfile && dupProfile !== 'undefined') { hasDuplicatedProfile = JSON.parse(dupProfile); }
		// const hasClaimRequest = JSON.parse(this.localStorage.get('hasClaimRequest'));
		// const consolidationExpiryDate = JSON.parse(this.localStorage.get('consolidationExpiryDate'));
		// this.setHasDuplicatedProfile(hasDuplicatedProfile);
		// this.setHasClaimRequest(hasClaimRequest);
		// this.setConsolidationExpiryDate(consolidationExpiryDate);
		// this.setUserNavigation(this.localStorage.get('userNavigation'));
	}

	getConsolidationExpiryDate() {
		return this.consolidationExpiryDate;
	}

	setCurrentBusinessOwnerId(id) {
		this.currentBusinessOwnerId = id;
	}

	setUserNavigation(url) {
		this.userNavigation = url;
		this.localStorage.save('userNavigation', url);
	}

	getUserNavigation() {
		return this.userNavigation;
	}

	getCurrentBusinessOwnerId() {
		return this.currentBusinessOwnerId;
	}

	setHasDuplicatedProfile(hasDuplicatedProfile) {
		this.hasDuplicatedProfile = hasDuplicatedProfile;
		this.localStorage.save('hasDuplicatedProfile', JSON.stringify(hasDuplicatedProfile));
	}

	getHasDuplicatedProfile() {
		return this.hasDuplicatedProfile;
	}

	setHasClaimRequest(hasClaimRequest) {
		this.hasClaimRequest = hasClaimRequest;
		this.localStorage.save('hasClaimRequest', JSON.stringify(hasClaimRequest));
	}

	getHasClaimRequest() {
		return this.hasClaimRequest;
	}

	setUserSession(res) {
		this.setConsolidationExpiryDate(
			res?.consolidationExpiryDate
		);
		this.setHasClaimRequest(res?.hasClaimRequest);
		this.setHasDuplicatedProfile(
			res?.hasDuplicatedProfile
		);
	}

	setConsolidationExpiryDate(consolidationExpiryDate) {
		this.consolidationExpiryDate = consolidationExpiryDate;
		this.localStorage.save('consolidationExpiryDate', JSON.stringify(consolidationExpiryDate));
	}

	getDuplicateProfiles(): Promise<ConsolidatedProfile[]> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/agent-managers/duplicate-profiles`;
		return this.apiClientHelper.getForPromise(url);
	}

	getConsolidateProfileOtp(): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/agent-managers/consolidation/otp`;
		return this.apiClientHelper.getForPromise(url);
	}

	validateProfileCredentials(params): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/agent-managers/consolidation/otp/validate`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	submitConsolidatedProfileLiveNess(params): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/agent-managers/consolidation/face-validation`;
		return this.apiClientHelper.newPostAsFormDataForPromise(url, params, false);
	}

	acceptProfileClaimRequest(): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/agent-managers/consolidation/profile-claim/accept`;
		return this.apiClientHelper.postForPromise(url, '');
	}

	claimConsolidateProfile(param): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/agent-managers/consolidation/claim-profile`;
		return this.apiClientHelper.postForPromise(url, param);
	}
}
